import { classes } from '@lc/libreact'
import type { ReactNode } from 'react'
import styles from './BlockContainer.scss'

type BlockContainerProps = {
	children: ReactNode
	className?: string
	shadow?: boolean
	id?: string
}

export function BlockContainer({
	children,
	className,
	shadow,
}: BlockContainerProps) {
	return (
		<div
			className={classes(
				styles.blockContainer,
				[styles.shadow, shadow],
				className,
			)}
		>
			<>{children}</>
		</div>
	)
}
